import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";

// import { queryEntities } from "../misc";
import { getKpisForProvidersWithCategoryChart } from "../opendata";
import { FigureSolidDashKpiProvider } from "./categoryChartData.types";
import { getPerConnectionResults } from "./getPerConnectionResults";

export const fetchFigureSolidDashPerConnectionKpiProviderChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProvider> => {
    const provider = providers?.[0];
    if (!metadata || !provider || !categoryChart || kpis == null || !kpis?.length) return null;

    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, [provider], true, categoryChart);
    if (!kpiReportResults) return null;

    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    const { unit, year, figures, graph } = getPerConnectionResults(
        kpis,
        metadata,
        kpiReportResults,
        [provider],
        // [kpis[0][2] ?? ""],
        [provider?.name],
        kpis[0][2] ?? "",
        category,
        categoryChart
    );

    return {
        title: categoryChart.displayTitle,

        kpiCode: null,
        schemeType: null,
        waterProvider: provider,
        unit,
        year,

        figure: figures?.[0],
        graph:
            graph == null
                ? null
                : {
                      measure: graph?.measure,
                      header: graph?.header,
                      years: graph?.years ?? [],
                      providerMedianSeriesName: graph?.providerMedianSeriesNames?.[0],
                      providerMedianData: graph?.providerMedianData?.[0],
                      providerMedianAnnotation: graph?.providerMedianAnnotations?.[0],

                      //   largeProviderAverageData: graph?.largeProviderAverageData ?? [],
                      //   largeProviderAverageSeriesName: graph?.largeProviderAverageSeriesName ?? "",
                      lineData: graph?.linesData?.[0] ?? [],
                      lineDataSeriesName: graph?.linesDataSeriesName?.[0] ?? "",
                      footer: graph?.footer
                  }
    };
};
